<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Detail Cek Gadai</h5>
            </template>
            <div :class="isActiveFotoRight ? 'split-view-container' : ''">
                <b-row :class="isActiveFotoRight ? 'h-100 m-0' : ''">
                    <b-col cols="12" :sm="isActiveFotoRight ? 8: 12" :class="isActiveFotoRight ? 'h-100 p-0 border-right' : ''">
                        <div :class="isActiveFotoRight ? 'scroll-area' : ''">
                            <DetailGadaiKomp
                                :detailGadai="dataDetailCekGadai.gadaiDetail"
                                :isActiveFotoRight="isActiveFotoRight"
                                :isActiveFotoMobile="isActiveFotoMobile"
                                :isFromCekGadai="true"
                                :isMobile="isMobile"
                                @onActiveFotoRight="onActiveFotoRight"
                                @onActiveFotoMobile="onActiveFotoMobile"
                            />
                            <div v-if="dataDetailCekGadai.ku != null" class="detail-data-wrapper mt-4 mb-4">
                                <h6 class="form-title">LAPORAN KEPALA UNIT</h6>
                                <b-row class="mb-2">
                                    <b-col cols="4" class="detail-data-label">Nama</b-col>
                                    <b-col>{{ dataDetailCekGadai.ku.name }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="4" class="detail-data-label">Status</b-col>
                                    <b-col>{{ dataDetailCekGadai.ku.status }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="4" class="detail-data-label">Tanggal</b-col>
                                    <b-col v-if="dataDetailCekGadai.ku.processedAt != null">
                                        {{ $helper.changeDateFormat(dataDetailCekGadai.ku.processedAt) }} {{ $helper.changeDateFormatGetHour(dataDetailCekGadai.ku.processedAt) }}
                                    </b-col>
                                    <b-col v-else>-</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="4" class="detail-data-label">Keterangan</b-col>
                                    <b-col v-if="dataDetailCekGadai.ku.keterangan != null">{{ dataDetailCekGadai.ku.keterangan }}</b-col>
                                    <b-col v-else>-</b-col>
                                </b-row>
                            </div>
                            <div v-if="dataDetailCekGadai.kc != null" class="detail-data-wrapper mb-4">
                                <h6 class="form-title">LAPORAN KEPALA CABANG</h6>
                                <b-row class="mb-2">
                                    <b-col cols="4" class="detail-data-label">Nama</b-col>
                                    <b-col>{{ dataDetailCekGadai.kc.name }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="4" class="detail-data-label">Status</b-col>
                                    <b-col>{{ dataDetailCekGadai.kc.status }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="4" class="detail-data-label">Tanggal</b-col>
                                    <b-col v-if="dataDetailCekGadai.kc.processedAt != null">
                                        {{ $helper.changeDateFormat(dataDetailCekGadai.kc.processedAt) }} {{ $helper.changeDateFormatGetHour(dataDetailCekGadai.kc.processedAt) }}
                                    </b-col>
                                    <b-col v-else>-</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="4" class="detail-data-label">Keterangan</b-col>
                                    <b-col v-if="dataDetailCekGadai.kc.keterangan != null">{{ dataDetailCekGadai.kc.keterangan }}</b-col>
                                    <b-col v-else>-</b-col>
                                </b-row>
                            </div>
                            <div v-if="dataDetailCekGadai.kcs != null" class="detail-data-wrapper mb-4">
                                <h6 class="form-title">LAPORAN AREA MANAGER</h6>
                                <b-row class="mb-2">
                                    <b-col cols="4" class="detail-data-label">Nama</b-col>
                                    <b-col>{{ dataDetailCekGadai.kcs.name }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="4" class="detail-data-label">Status</b-col>
                                    <b-col>{{ dataDetailCekGadai.kcs.status }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="4" class="detail-data-label">Tanggal</b-col>
                                    <b-col v-if="dataDetailCekGadai.kcs.processedAt != null">
                                        {{ $helper.changeDateFormat(dataDetailCekGadai.kcs.processedAt) }} {{ $helper.changeDateFormatGetHour(dataDetailCekGadai.kcs.processedAt) }}
                                    </b-col>
                                    <b-col v-else>-</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="4" class="detail-data-label">Keterangan</b-col>
                                    <b-col v-if="dataDetailCekGadai.kcs.keterangan != null">{{ dataDetailCekGadai.kcs.keterangan }}</b-col>
                                    <b-col v-else>-</b-col>
                                </b-row>
                            </div>
                            <div v-if="dataDetailCekGadai.pusat != null" class="detail-data-wrapper mb-4">
                                <h6 class="form-title">LAPORAN PUSAT</h6>
                                <b-row class="mb-2">
                                    <b-col cols="4" class="detail-data-label">Nama</b-col>
                                    <b-col>{{ dataDetailCekGadai.pusat.name }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="4" class="detail-data-label">Status</b-col>
                                    <b-col>{{ dataDetailCekGadai.pusat.status }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="4" class="detail-data-label">Tanggal</b-col>
                                    <b-col v-if="dataDetailCekGadai.pusat.processedAt != null">
                                        {{ $helper.changeDateFormat(dataDetailCekGadai.pusat.processedAt) }} {{ $helper.changeDateFormatGetHour(dataDetailCekGadai.pusat.processedAt) }}
                                    </b-col>
                                    <b-col v-else>-</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="4" class="detail-data-label">Keterangan</b-col>
                                    <b-col v-if="dataDetailCekGadai.pusat.keterangan != null">{{ dataDetailCekGadai.pusat.keterangan }}</b-col>
                                    <b-col v-else>-</b-col>
                                </b-row>
                            </div>

                            <div v-if="dataDetailCekGadai.status != 'PEMANTAUAN'">
                                <div class="detail-data-wrapper mb-4" v-if="dataDetailCekGadai.status == 'PENDING' || dataDetailCekGadai.status == 'DALAM PENGECEKAN'">
                                    <h6 class="form-title">CEK GADAI</h6>
                                
                                    <b-row >
                                        <b-col lg="4" md="6">
                                            <b-form-group label="Keterangan" description="Wajib diisi bila menyatakan 'Yakin Salah'">
                                                <b-form-textarea v-model="input.keterangan" name="keterangan"></b-form-textarea>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                
                                    <div v-if="!$helper.isNullOrEmpty(dataDetailCekGadai.fotoSbgAwal)" class="mt-2">
                                        <b-button variant="pgiBtn" @click="$bvModal.show('modal-preview-foto')" v-if="dataDetailCekGadai.status == 'PENDING' || dataDetailCekGadai.status == 'DALAM PENGECEKAN'" >Lihat SBG Awal</b-button>
                                    </div>
                                    <div class="d-flex flex-wrap mt-2" style="gap: 8px;">
                                        <b-button variant="pgiBtn" @click="confirmModal(1)" v-if="dataDetailCekGadai.status == 'PENDING'">Cek Terlebih Dahulu</b-button>
                                        <b-button variant="success" @click="confirmModal(2)" v-if="dataDetailCekGadai.status == 'PENDING' || dataDetailCekGadai.status == 'DALAM PENGECEKAN'">Yakin Benar</b-button>
                                        <b-button variant="danger" @click="confirmModal(3)" v-if="dataDetailCekGadai.status == 'PENDING' || dataDetailCekGadai.status == 'DALAM PENGECEKAN'">Yakin Salah</b-button>
                                    </div>
                            
                                    <b-alert v-if="$helper.isNullOrEmpty(dataDetailCekGadai.fotoSbgAwal)" show variant="danger" class="mt-3 mb-0">
                                        Perhatian! SBG Awal belum diupload!
                                    </b-alert>
                                </div>  
                            </div>
                        </div>
                    </b-col>
                    <transition name="slide-right">
                        <b-col v-if="isActiveFotoRight" cols="12" sm="4" class="h-100 p-0 bg-light d-none d-sm-block">
                            <div class="scroll-area p-3">
                                <h5 class="mb-3">Foto</h5>
                                <ImageCard
                                    v-for="(urlFoto, index) in dataDetailCekGadai.gadaiDetail.foto"
                                    :key="index"
                                    :src="urlFoto"
                                    :title="'Foto ' + (index + 1)" 
                                    @preview="openPreview"
                                />
                            </div>
                        </b-col>
                    </transition>
                </b-row>
            </div>

            <b-modal id="modal-preview-foto" size="xl" title="Foto SBG Awal">
                <div class="modal-foto-wrapper">
                    <img :src="dataDetailCekGadai.fotoSbgAwal" alt="Foto">
                </div>
                <template v-slot:modal-footer="{ cancel }">
                    <b-button variant="secondary" name="closePreviewBtn" @click="cancel()">
                        Close
                    </b-button>
                </template>
            </b-modal>
        </b-card>
        <ModalPreview modalId="modal-preview-gadai-c" :fotoPreview="activeFotoPreview" />
        <ModalConfirm id="modal-confirm-cekStatus" title="Confirm Cek Gadai" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengecek gadai ini? Anda dapat mengubah lagi menjadi yakin benar / salah dikemudian waktu." @submit="onCekStatus" />
        <ModalConfirm id="modal-confirm-yakinBenar" title="Confirm Yakin Benar" :isSubmitting="isSubmitting" desc="Status tidak dapat dirubah lagi setelah anda melakukan konfirmasi ini. Apakah anda yakin gadai ini benar?" @submit="onCekStatus" />
        <ModalConfirm id="modal-confirm-yakinSalah" title="Confirm Yakin Salah" :isSubmitting="isSubmitting" desc="Status tidak dapat dirubah lagi setelah anda melakukan konfirmasi ini. Apakah anda yakin gadai ini salah?" @submit="onCekStatus" />
    </div>
</template>

<script>

import DetailGadaiKomp from '../../../components/gadai/DetailGadaiKomp';
import ModalPreview from '@/components/webcam/ModalPreview'
import ImageCard from '@/components/common/ImageCard'

export default {
    name: 'detail-cek-gadai',
    components: {
        DetailGadaiKomp,
        ModalPreview,
        ImageCard
    },
    data(){
        return{
            id: null,
            approved: null,
            initStatus: 0,
            isSubmitting: false,
            input: {
                keterangan: ""
            },
            dataDetailCekGadai: [],
            activeFotoPreview: '',
            isActiveFotoRight: false,
            isMobile: false,
            isActiveFotoMobile: false
        }
    },
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getSingleCekGadai= this.$axios.get(`gadai-notifikasi/check/${this.id}`).then(response => {
                this.dataDetailCekGadai = response.data
            })

            Promise.all([getSingleCekGadai]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        //----------------- Cek Status Gadai -----------------
        
        onCekStatus(){
            let payload = new FormData()
            this.isSubmitting = true

            payload.append('id', this.id)
            payload.append('newStatus', this.approved)
            if(this.$helper.isNotNullAndNotEmpty(this.input.keterangan)) payload.append('keterangan', this.input.keterangan)
    
            this.$axios.post("gadai-notifikasi/check/process", payload).then(response => {
                if(this.approved == 1){
                    this.$helper.setFlash("Gadai berhasil dicek!")
                }else if(this.approved == 2){
                    this.$helper.setFlash("Gadai berhasil ditandai 'Yakin Benar'!")
                }else{
                    this.$helper.setFlash("Gadai berhasil ditandai 'Yakin Salah'!")
                }
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        confirmModal(id){
            if(id == 1){
                this.approved = 1
                this.$bvModal.show("modal-confirm-cekStatus")
            }else if(id == 2){
                this.approved = 2
                this.$bvModal.show("modal-confirm-yakinBenar")
            }else{
                if(this.input.keterangan == ""){
                    this.$helper.toastErr(this, "Mohon masukkan keterangan di dalam kotak Keterangan!")
                }else{
                    this.approved = 3
                    this.$bvModal.show("modal-confirm-yakinSalah")
                }
            }
        },

        openPreview(item) {
            this.activeFotoPreview = item
            this.$bvModal.show("modal-preview-gadai-c")
        },

        onActiveFotoRight() {
            this.isActiveFotoRight = !this.isActiveFotoRight
        },
        onActiveFotoMobile() {
            this.isActiveFotoMobile = !this.isActiveFotoMobile
        },
        checkDevice() {
            this.isMobile = window.innerWidth < 576
            if (this.isMobile) {
                this.isActiveFotoRight = false
            } else {
                this.isActiveFotoMobile = false
            }
        },
    },

    mounted() {
        this.checkDevice()
        window.addEventListener('resize', this.checkDevice)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkDevice)
    },

    created(){
        this.init()
    }
}
</script>

<style scoped>
.slide-right-enter,
.slide-right-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>